const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
    '& th': {
      color: 'black',
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    boxShadow:'none!important',
  },
  fiberInfo:{
    fontWeight:300
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/fiber/types/bidirectional/styles.js